import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { Paper, Box, Button, Typography, IconButton, TextField, Divider, Table, TableHead, TableBody, TableCell, TableRow, Autocomplete } from '@mui/material';
import { ApolloClient, ApolloProvider, gql, InMemoryCache, useQuery } from "@apollo/client";
import { Modal } from "./modal";
import { MoreVert } from '@mui/icons-material'

const client = new ApolloClient({
  uri: localStorage.getItem('HEXHIVE_API') || 'http://localhost:7030/graphql',
  credentials: 'include',
  cache: new InMemoryCache()
})

export default function Root(props) {
  return (
    <ApolloProvider client={client}>
      <RootWrapped {...props} />
    </ApolloProvider>
  )
}

interface TypeField {
  name: string;
  type: {
    name: string,
    kind: string;
    ofType?: {
      name: string;
      fields?: TypeField[];
    }
  }
}

interface InputField {
  name: string;
  type: {
    name: string,
    kind: string;
    ofType?: {
      name: string;
      inputFields?: InputField[];
    }
  }
}

export interface RootProps{
  id: string;

  app: any;

  // getData: () => Promise<any[]>;
  // createData: (item: any) => Promise<void>;
  // updateData: (item: any) => Promise<void>;
  // deleteData: (item: any) => Promise<void>;

  // onSelectRow?: (row: any) => void;
}

const RootWrapped : React.FC<RootProps> = (props) => {

  const [ form, setForm ] = useState<any>({});

  useEffect(() => {
    setForm({
      ...props.app
    })
  }, [props.app])

  const { data } = useQuery(gql`
    query Views {
      rootViews {
        id  
        name

        shadow
      }

      models{
        id
        name
      }
    }  
  `)

  const save = () => {
    fetch(localStorage.getItem('HEXHIVE_API') + '/../apps', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },  
      body: JSON.stringify({
        id: (props.id && props.id !== 'create') ? props.id : undefined,
        name: form.name,
        view: form.view,
        types: form.types
      })
    });
  }

  return <div style={{
    minHeight: 0,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '8px'
  }}>
  
    <Box sx={{ display: 'flex', paddingBottom: '8px', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography>App creator</Typography>

      <Button onClick={save} variant="contained">Save</Button>
    </Box>
    <Divider />
    <Box sx={{ flex: 1, minHeight: 0, gap: '8px', flexDirection: 'column', display: 'flex', overflow: 'scroll' }}>

      <TextField 
        value={form.name || ''}
        onChange={(e) => setForm({...form, name: e.target.value})}
        label="Name" 
        size="small" 
        fullWidth />
      <Typography>
        Select a view that you'd like to share    
      </Typography>

      <Autocomplete
        value={form.view}
        onChange={(e, value) => setForm({...form, view: value})}
        getOptionLabel={(option: any) => typeof(option) == 'string' ? option : option.name}
        renderInput={(params) => <TextField {...params} size="small" />}
        options={(data?.rootViews || []).filter((a) => !a.shadow)}/>

      <Typography>
        Select the types your view needs
      </Typography>
      <Autocomplete
        value={form.types || []}
        onChange={(e, value) => setForm({...form, types: value})}
        multiple
        getOptionLabel={(option: any) => typeof(option) == 'string' ? option : option.name}
        renderInput={(params) => <TextField {...params} size="small" />}
        options={data?.models || []} />
    </Box>
  </div>;
}
